import type { TranslationModule } from '../types';

export const modulesTranslations: TranslationModule = {
  ro: {
    dosar: {
      label: "Nr. dosar instanță",
      tooltip: "Caută dosare după numărul complet sau parțial de dosar",
      placeholder: "Introduceți numărul dosarului (ex: 1234/303/2024)...",
      helpDesc: "Găsește un dosar în instanță după număr.",
      helpExample: "Ex.: 1234/303/2024."
    },
    firma: {
      label: "CUI / Denumire firmă",
      tooltip: "Verifică firme după cod fiscal (CUI) sau denumire comercială",
      placeholder: "CUI/Folosiți denumirea oficială completă din Registrul Comerțului\nIncludeți forma juridică (SRL, SA, etc.)",
      helpDesc: "Caută o firmă după CUI sau denumirea oficială.",
      helpExample: "Ex.: denumirea completă, inclusiv SRL."
    },
    dictionar: {
      label: "Dicționar",
      tooltip: "Găseşte definiții şi explicații pentru termeni juridici",
      placeholder: "Introduceți termenul juridic (ex: prescripție, servitute)...",
      helpDesc: "Explică termenii juridici din dicționarul platformei.",
      helpExample: "Ex.: sensul termenului „servitute”."
    },
    agenda: {
      label: "Agendă",
      tooltip: "Caută instanțe, judecătorii, tribunale şi contacte juridice",
      placeholder: "Introduceți numele instanței sau tipul instituției...",
      helpDesc: "Găsește instituții și date de contact juridice.",
      helpExample: "Ex.: Tribunalul București."
    },
    legislatie: {
      label: "Legislație",
      tooltip: "Găseşte articole din legi, coduri şi acte normative",
      placeholder: "Introduceți cuvinte cheie din lege (ex: art. 1357 Cod Civil)...",
      helpDesc: "Caută în legi, coduri și acte normative.",
      helpExample: "Ex.: art. 1357 Cod civil."
    },
    modele: {
      label: "Modele documente & Cereri",
      tooltip: "Descărcă modele de contracte, cereri şi formulare juridice gata de completat",
      placeholder: "Introduceți tipul documentului (ex: contract vânzare, cerere)...",
      helpDesc: "Caută modele de cereri, contracte și formulare.",
      helpExample: "Ex.: cerere de chemare în judecată."
    },
    jurisprudenta: {
      label: "Hotărâri Judecătorești",
      tooltip: "Caută în peste 15 milioane de hotărâri judecătoreşti şi decizii ale instanțelor române",
      placeholder: "Introduceți cuvinte cheie (ex: daune morale, evacuare, divorț)...",
      helpDesc: "Caută hotărâri și decizii ale instanțelor.",
      helpExample: "Ex.: hotărâri despre daune morale."
    },
    practica_neunitara: {
      label: "Practică neunitară",
      tooltip: "Caută probleme de drept discutate pentru unificarea practicii instanțelor",
      placeholder: "Introduceți problema de drept (ex: prescripție, competență, executare silită)...",
      helpDesc: "Caută probleme de drept discutate pentru unificarea practicii.",
      helpExample: "Ex.: interpretări diferite privind prescripția."
    },
    jurnal_practica_judiciara: {
      label: "Jurnal de practică judiciară",
      tooltip: "Caută analize, culegeri și soluții relevante din practica instanțelor",
      placeholder: "Introduceți tema juridică (ex: clauze abuzive, contencios, executare silită)...",
      helpDesc: "Caută analize și culegeri de practică judiciară.",
      helpExample: "Ex.: analize despre clauze abuzive."
    },
    circumscriptii: {
      label: "Instanța mea competentă",
      tooltip: "Află care instanță este competentă pentru o localitate, stradă sau cod poştal",
      placeholder: "Pentru identificarea instanței competente, introduceți localitatea or codul poștal, iar pentru București, strada.",
      helpDesc: "Identifică instanțele aferente unei localități sau adrese.",
      helpExample: "Ex.: localitate, cod poștal sau stradă din București."
    },
    persoane: {
      label: "Căutare Persoane",
      tooltip: "Caută administratori, directori și reprezentanți legali în 3.6 milioane înregistrări ONRC",
      placeholder: "Căutați după numele unei persoane pentru a vedea în ce firme apare ca administrator sau reprezentant legal (minim 10 caractere).",
      helpDesc: "Caută persoane în datele despre firme și reprezentanții lor.",
      helpExample: "Ex.: numele unui administrator."
    },
    litigii: {
      label: "Procese în justiție",
      tooltip: "Dosare în instanță în care figurează persoane fizice sau juridice.",
      placeholder: "Introduceți numele persoanei sau denumirea societății...",
      helpDesc: "Caută dosare în instanță în care figurează persoane fizice sau juridice.",
      helpExample: "Ex.: numele persoanei sau denumirea firmei."
    }
  },
  en: {
    dosar: {
      label: "Court Case File No.",
      tooltip: "Search court cases by complete or partial case number",
      placeholder: "Enter case number (e.g., 1234/303/2024)...",
      helpDesc: "Find a court case by number.",
      helpExample: "Ex.: 1234/303/2024."
    },
    firma: {
      label: "CUI / Company Name",
      tooltip: "Verify companies by fiscal code (CUI) or commercial name",
      placeholder: "CUI/Use the full official name from the Trade Register\nInclude legal status (SRL, SA, etc.)",
      helpDesc: "Search a company by tax ID (CUI) or official name.",
      helpExample: "Ex.: full legal name, including SRL or SA."
    },
    dictionar: {
      label: "Dictionary",
      tooltip: "Find definitions and explanations for legal terms",
      placeholder: "Enter legal term (e.g., statute of limitations, easement)...",
      helpDesc: "Explains legal terms from the platform dictionary.",
      helpExample: "Ex.: meaning of 'easement' or 'prescription'."
    },
    agenda: {
      label: "Directory",
      tooltip: "Search court jurisdictions, tribunals, and legal contacts",
      placeholder: "Enter court name or type of institution...",
      helpDesc: "Find legal institutions and judicial contact info.",
      helpExample: "Ex.: Bucharest Court of Appeal."
    },
    legislatie: {
      label: "Legislation",
      tooltip: "Find articles from laws, codes, and normative acts",
      placeholder: "Enter law keywords (e.g., art. 1357 Civil Code)...",
      helpDesc: "Search within statutory laws, codes, and enactments.",
      helpExample: "Ex.: art. 1357 Civil Code."
    },
    modele: {
      label: "Document Templates & Forms",
      tooltip: "Download templates for contracts, applications, and forms",
      placeholder: "Enter document type (e.g., sale contract, application)...",
      helpDesc: "Find document templates, court petitions, and contract drafts.",
      helpExample: "Ex.: statement of claim, sales contract."
    },
    jurisprudenta: {
      label: "Court Decisions (Jurisprudence)",
      tooltip: "Search across over 15 million judicial and court decisions",
      placeholder: "Enter keywords (e.g., moral damages, eviction)...",
      helpDesc: "Search court judgments and judicial decisions.",
      helpExample: "Ex.: decisions on moral damages, evictions."
    },
    practica_neunitara: {
      label: "Non-uniform case law",
      tooltip: "Search legal issues discussed to harmonize court practice",
      placeholder: "Enter a legal issue (e.g., limitation period, jurisdiction, enforcement)...",
      helpDesc: "Search legal issues discussed for judicial uniformity.",
      helpExample: "Ex.: divergent interpretations on limitation periods."
    },
    jurnal_practica_judiciara: {
      label: "Judicial Practice Journal",
      tooltip: "Search analyses, collections, and relevant solutions from judicial practice",
      placeholder: "Enter a legal topic (e.g., unfair terms, administrative litigation, enforcement)...",
      helpDesc: "Search analytical reviews and case-law casebooks.",
      helpExample: "Ex.: analysis of unfair terms, enforcement."
    },
    circumscriptii: {
      label: "My Competent Court",
      tooltip: "Find which court is competent for your locality, street, or postal code",
      placeholder: "Enter locality, street or zip code to find your court...",
      helpDesc: "Identify competent courts for a locality or address.",
      helpExample: "Ex.: city, postal code or street in Bucharest."
    },
    persoane: {
      label: "People Search",
      tooltip: "Search directors, administrators, and legal representatives in 3.6 million ONRC records",
      placeholder: "Search by a person's name to see in which companies they appear as administrator or legal representative (min. 10 characters).",
      helpDesc: "Search individuals across company registries and legal representatives.",
      helpExample: "Ex.: director or manager name."
    },
    litigii: {
      label: "Court Cases",
      tooltip: "Court cases involving natural persons or legal entities.",
      placeholder: "Enter person name or company name...",
      helpDesc: "Search court cases involving natural persons or legal entities.",
      helpExample: "Ex.: person name or company name."
    }
  },
  fr: {
    dosar: {
      label: "N° de dossier du tribunal",
      tooltip: "Rechercher des dossiers de tribunal par numéro complet ou partiel",
      placeholder: "Saisissez le numéro de dossier (ex : 1234/303/2024)...",
      helpDesc: "Trouvez un dossier judiciaire par son numéro.",
      helpExample: "Ex. : 1234/303/2024."
    },
    firma: {
      label: "N° Siret / Nom de l'entreprise",
      tooltip: "Vérifier les entreprises par code fiscal (CUI) ou dénomination commerciale",
      placeholder: "N° Fiscal/Utilisez le nom officiel complet du Registre du Commerce\nIncluez la forme juridique (SRL, SA, etc.)",
      helpDesc: "Recherchez une entreprise par CUI ou dénomination officielle.",
      helpExample: "Ex. : dénomination complète, y compris SRL."
    },
    dictionar: {
      label: "Dictionnaire",
      tooltip: "Trouver des définitions et des explications pour des termes juridiques",
      placeholder: "Saisissez le terme juridique (ex : prescription, servitude)...",
      helpDesc: "Explique les termes juridiques du dictionnaire de la plateforme.",
      helpExample: "Ex. : sens du terme « servitude »."
    },
    agenda: {
      label: "Annuaire",
      tooltip: "Rechercher des juridictions, des tribunaux et des contacts juridiques",
      placeholder: "Saisissez le nom du tribunal ou le type d'institution...",
      helpDesc: "Trouvez les institutions et coordonnées juridiques.",
      helpExample: "Ex. : Tribunal de Bucarest."
    },
    legislatie: {
      label: "Législation",
      tooltip: "Trouver des articles de lois, de codes et d'actes normatifs",
      placeholder: "Saisissez des mots-clés de loi (ex : art. 1357 Code Civil)...",
      helpDesc: "Recherchez dans les lois, codes et actes normatifs.",
      helpExample: "Ex. : art. 1357 Code civil."
    },
    modele: {
      label: "Modèles de documents & Requêtes",
      tooltip: "Télécharger des modèles de contrats, de requêtes et de formulaires",
      placeholder: "Saisissez le type de document (ex : contrat de vente, requête)...",
      helpDesc: "Trouvez des modèles de requêtes, contrats et formulaires.",
      helpExample: "Ex. : assignation en justice, contrat de vente."
    },
    jurisprudenta: {
      label: "Décisions de Justice (Jurisprudence)",
      tooltip: "Rechercher parmi plus de 15 millions de décisions judiciaires des tribunaux",
      placeholder: "Saisissez des mots-clés (ex : dommages-intérêts, expulsion)...",
      helpDesc: "Recherchez les arrêts et jugements des cours et tribunaux.",
      helpExample: "Ex. : décisions sur le préjudice moral."
    },
    practica_neunitara: {
      label: "Pratique judiciaire non uniforme",
      tooltip: "Rechercher les questions de droit examinées afin d'harmoniser la pratique des tribunaux",
      placeholder: "Saisissez une question de droit (ex : prescription, compétence, exécution forcée)...",
      helpDesc: "Recherchez les questions de droit pour l'unification de la jurisprudence.",
      helpExample: "Ex. : divergences d'interprétation sur la prescription."
    },
    jurnal_practica_judiciara: {
      label: "Revue de pratique judiciaire",
      tooltip: "Rechercher des analyses, recueils et solutions pertinentes issus de la pratique judiciaire",
      placeholder: "Saisissez un thème juridique (ex : clauses abusives, contentieux administratif, exécution forcée)...",
      helpDesc: "Recherchez les analyses et recueils de pratique judiciaire.",
      helpExample: "Ex. : analyses sur les clauses abusives."
    },
    circumscriptii: {
      label: "Mon Tribunal Compétent",
      tooltip: "Découvrez quel tribunal est compétent pour votre localité, rue ou code postal",
      placeholder: "Saisissez la localité, rue ou code postal pour trouver le tribunal...",
      helpDesc: "Identifiez les juridictions compétentes pour une commune ou une adresse.",
      helpExample: "Ex. : localité, code postal ou rue de Bucarest."
    },
    persoane: {
      label: "Recherche de Personnes",
      tooltip: "Recherchez des administrateurs, directeurs et représentants légaux parmi 3,6 millions d'enregistrements de l'ONRC",
      placeholder: "Recherchez par le nom d'une personne pour voir dans quelles entreprises elle apparaît comme administrateur ou représentant legal (min. 10 caractères).",
      helpDesc: "Recherchez des personnes dans les registres d'entreprises et représentants légaux.",
      helpExample: "Ex. : nom d'un administrateur."
    },
    litigii: {
      label: "Procès en justice",
      tooltip: "Dossiers judiciaires impliquant des personnes physiques ou morales.",
      placeholder: "Entrez le nom d'une personne physique ou la dénomination d'une société...",
      helpDesc: "Recherchez des dossiers judiciaires impliquant des personnes physiques ou morales.",
      helpExample: "Ex. : nom de personne ou dénomination de société."
    }
  }
};

export default modulesTranslations;
